import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { setUnauthorizedHandler } from "../shared/api/apiClient";

//Globale Reaktion auf 401-Antworten des Backends (Session ungueltig/abgelaufen).

export default function AuthSessionHandler() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    setUnauthorizedHandler(() => {
      // Mehrere parallele Requests koennen gleichzeitig 401 liefern. Nach der
      // ersten Navigation ist der Pfad nicht mehr /app -> weitere Aufrufe ignorieren.
      if (!window.location.pathname.startsWith("/app")) {
        return;
      }
      navigate("/", { replace: true });
      void queryClient.cancelQueries();
      queryClient.clear();
    });

    return () => setUnauthorizedHandler(null);
  }, [navigate, queryClient]);

  return null;
}
